import React, { useState } from "react";

interface ImageSlideshowProps {
  images: (string | null)[];
  altText?: string;
}

const ImageSlideshow: React.FC<ImageSlideshowProps> = ({
  images,
  altText = "Service image",
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const validImages = images.filter((img): img is string => img !== null);

  if (!images || validImages.length === 0) {
    return null;
  }

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? validImages.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === validImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <div className="image-slideshow">
      <div className="slideshow-container">
        <img
          src={validImages[currentIndex]}
          alt={`${altText} ${currentIndex + 1}`}
          className="slideshow-image"
        />

        {validImages.length > 1 && (
          <>
            <button
              className="slideshow-nav prev"
              onClick={goToPrevious}
              aria-label="Previous image"
            >
              ‹
            </button>
            <button
              className="slideshow-nav next"
              onClick={goToNext}
              aria-label="Next image"
            >
              ›
            </button>

            <div className="slideshow-indicators">
              {validImages.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentIndex ? "active" : ""}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to image ${index + 1}`}
                />
              ))}
            </div>

            <div className="slideshow-counter">
              {currentIndex + 1} / {validImages.length}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ImageSlideshow;
